export const KOVAN_WETH_CONTRACT_ADDRESS = '0xd0a1e359811322d97991e03f863a0c30c2cf029c';
export const MAINNET_WETH_CONTRACT_ADDRESS = '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2';

export function getWethContractAddress(networkName) {
    if (networkName === "kovan") {
        return KOVAN_WETH_CONTRACT_ADDRESS;
    } else if (networkName === "homestead") {
        return MAINNET_WETH_CONTRACT_ADDRESS;
    } 
}